import { keepPreviousData, queryOptions } from '@tanstack/react-query'
import { Request } from 'commons/utils/request'
import { ClientPortalUsersActivityReportPayload } from '~bank-reports/types/ClientPortalUsersActivityReport'

export const clientPortalUsersReportQueryOptions = (deps: Partial<ClientPortalUsersActivityReportPayload>) =>
  queryOptions({
    queryKey: ['clientPortalUsersActivityReport', deps],
    queryFn: () => Request.post(Request.urls.bank.clientPortalUsersActivityReport, { ...deps }),
    structuralSharing: true,
    staleTime: 1000,
    placeholderData: keepPreviousData
  })
